var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 551.391,
    height: 551.391,
    style: {
      enableBackground: "new 0 0 551.391 551.391"
    },
    viewBox: "0 0 551.391 551.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.695 0s-45.366 44.014-94.43 61.759c-363.333 131.419-210.1 387.518-205.101 388.362 0 0 20.374-35.48 47.896-55.717C336.704 266.015 372.2 118.233 372.2 118.233s-39.19 177.829-194.562 288.479c-34.316 24.426-57.552 84.568-67.388 144.679 0 0 24.325-9.828 34.785-12.49 4.079-26.618 12.607-52.106 27.025-74.875C389.211 489.88 460.332 314.903 469.623 253.89 491.552 109.79 413.695 0 413.695 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.f005dc0b1556a0e62ac6ad0844a10623.svg";
export { ForwardRef as ReactComponent };